import { useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Vehicle } from "../../../../api/vehiclesApi";
import { createVehicleInfoWindow } from "../../utils/vehicleHistoryUtils";
import { useHistoryHandler } from "./useHistoryHandler";

interface UseVehicleHistoryProps {
  map: google.maps.Map | null;
  selectedVehicleId?: number;
  selectedVehicle?: Vehicle | null;
  token?: string | null;
  defaultCenter: google.maps.LatLngLiteral;
  defaultZoom: number;
  showRoute: boolean;
  onClose?: () => void;
}

interface VehicleHistoryState {
  path: google.maps.LatLngLiteral[];
  pauses: google.maps.LatLngLiteral[];
  startPosition: google.maps.LatLngLiteral | null;
  isLoading: boolean;
}

export const useVehicleHistory = ({
  map,
  selectedVehicleId,
  selectedVehicle,
  token,
  defaultCenter,
  defaultZoom,
  showRoute,
  onClose,
}: UseVehicleHistoryProps) => {
  const theme = useTheme();
  const [historyState, setHistoryState] = useState<VehicleHistoryState>({
    path: [],
    pauses: [],
    startPosition: null,
    isLoading: false,
  });
  const infoWindowRef = useRef<google.maps.InfoWindow | null>(null);

  const { clearMapObjects, fitRouteBounds, isLoading } = useHistoryHandler({
    map,
    selectedVehicleId,
    selectedVehicle,
    token,
    showRoute,
    onHistoryProcessed: (history) => {
      const currentPosition = selectedVehicle && {
        lat: selectedVehicle.lastLatitude || 0,
        lng: selectedVehicle.lastLongitude || 0,
      };

      // if (map && selectedVehicle && currentPosition) {
      //   // Create and show info window
      //   if (infoWindowRef.current) {
      //     infoWindowRef.current.close();
      //   }
      //   infoWindowRef.current = createVehicleInfoWindow(
      //     selectedVehicle,
      //     currentPosition,
      //     map,
      //     theme.palette.mode === "dark"
      //   );

      //   // Add close listener to reset view and deselect vehicle
      //   google.maps.event.addListener(
      //     infoWindowRef.current,
      //     "closeclick",
      //     () => {
      //       clearMapObjects();
      //       if (map) {
      //         map.setCenter(defaultCenter);
      //         map.setZoom(defaultZoom);
      //       }
      //       setHistoryState({
      //         path: [],
      //         pauses: [],
      //         startPosition: null,
      //         isLoading: false,
      //       });
      //       onClose?.();
      //     }
      //   );

      //   infoWindowRef.current.open(map);
      // }

      setHistoryState((prev) => ({ ...prev, isLoading: false }));
    },
  });

  // Cleanup effect
  useEffect(() => {
    return () => {
      if (infoWindowRef.current) {
        infoWindowRef.current.close();
        infoWindowRef.current = null;
      }
    };
  }, []);

  return {
    ...historyState,
    isLoading,
    fitRouteBounds,
  };
};
